<template>
  <v-icon
    :class="{ 'is-active': active }"
    class="LKIconToggle"
  >
    <template v-if="loading">
      mdi-spin mdi-sync
    </template>

    <template v-else>
      mdi-chevron-down
    </template>
  </v-icon>
</template>

<script>
export default {
  name: 'LKIconToggle',
  props: {
    loading: Boolean,
    active: Boolean,
  },
}
</script>

<style lang="scss">

.LKIconToggle {
  transition: all 0.2s;

  &.v-icon {
    color: $webflow-color-black;
  }

  &.is-active {
    transform: rotate(180deg);
  }
}
</style>
